<script setup>
import { computed, onMounted } from 'vue'

import ExistingRadiator from './components/ExistingRadiator.vue'
import { getStrings } from './lib/i18n'
import { trackEvent } from './lib/tracking'

const props = defineProps({
  lang: {
    type: String,
    default: 'en',
  },
  market: {
    type: String,
    default: '',
  },
})

const strings = computed(() => getStrings(props.lang))
const getMarketFromUrl = () => {
  if (typeof window === 'undefined') return ''
  const params = new URLSearchParams(window.location.search)
  return params.get('market') || ''
}
const resolvedMarket = computed(() => props.market || getMarketFromUrl() || '')

onMounted(() => {
  trackEvent('calculator_existing_loaded', { market: resolvedMarket.value })
})
</script>

<template>
  <div class="existing-calculator app-root">
    <ExistingRadiator :strings="strings" :market="resolvedMarket" />
  </div>
</template>

<style src="./styles/base.css"></style>

<style scoped>
.existing-calculator {
  width: 100%;
  max-width: 720px;
  margin: 0 auto;
}
</style>
